var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shapes 1",
    clipPath: "url(#clip0_338_1002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.1846 62.9999H63.0009V35.1836H35.1846V62.9999ZM38.8726 38.8716H59.3128V59.3118H38.8726V38.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.9689 30.0624C56.2573 30.0624 63.0004 23.3193 63.0004 15.0309C63.0004 6.74306 56.2573 0 47.9689 0C39.6806 0 32.938 6.74306 32.938 15.0314C32.938 23.3198 39.6811 30.0624 47.9689 30.0624ZM47.9689 3.68804C54.2237 3.68804 59.3123 8.7767 59.3123 15.0314C59.3123 21.2861 54.2237 26.3743 47.9689 26.3743C41.7142 26.3743 36.626 21.2857 36.626 15.0309C36.626 8.77622 41.7147 3.68804 47.9689 3.68804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 28.4623H32.3248L16.1624 0L0 28.4623ZM6.33547 24.7742L16.1624 7.46885L25.9893 24.7742H6.33547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.83174 35.8701L0 49.4351L7.83174 63H23.4952L31.3274 49.4351L23.4952 35.8696H7.83174V35.8701ZM21.3659 59.312H9.96103L4.25858 49.4351L9.96103 39.5577H21.3659L27.0684 49.4351L21.3659 59.312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.2b72aa820e08ff0189c5c1d555fd1840.svg";
export { ForwardRef as ReactComponent };